<template>
  <section class="section">
    <div class="content has-text-grey has-text-centered">
      <p>
        <i class="fas fa-frown-open" style="width:5em;height:5em;"></i>
      </p>
      <p>{{ messageEmpty }}</p>
    </div>
  </section>
</template>
<script>
export default {
    props: ["messageEmpty"]
}
</script>